// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"36d26d78301cd3a3","5607":"9e982f343bb61e4d","6719":"aa876dd4f175ac3d"}[chunkId] + ".css";
};